"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../shared/UiStateController");
var antd_1 = require("antd");
var antd_2 = require("antd");
var routes_1 = require("../../shared/includes/routes");
var antd_3 = require("antd");
var UILanguage_1 = require("../../UILanguage");
var webAApi_1 = require("../../api/webAApi");
var webTransport_1 = require("../../../shared/modules/webTransport");
var UIUtils_1 = require("../../../shared/modules/UIUtils");
var coreAdmin_1 = require("../../coreAdmin");
var groups_1 = require("../../shared/includes/groups");
var Option = antd_3.Select.Option;
var InputGroup = antd_2.Input.Group;
var PAuth = /** @class */ (function (_super) {
    __extends(PAuth, _super);
    function PAuth(props) {
        var _this = _super.call(this, props) || this;
        _this.DEF_LANG = "RU";
        return _this;
    }
    PAuth.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            login: "",
            password: "",
            lang: UILanguage_1.IUILanguageFactory.getLangInstance(this.props.state.getLang()),
            visible: false
        }, function () {
            if (localStorage.hasOwnProperty("mg-login")) {
                setTimeout(function () {
                    _this.setState({ visible: true });
                }, 1000);
            }
            else {
                _this.setState({ visible: true });
            }
            _this.props.state.setLang(_this.DEF_LANG);
        });
    };
    PAuth.prototype.DoLoginAction = function (Login, Password, onError) {
        var _this = this;
        webAApi_1.DoAdminLoginRequest.exec({ auth_usrlogin: Login }, function (lrResp) {
            var _sign = webTransport_1.webTransport.calcSign(lrResp.loginkey, Login, Password);
            var _TZoneOffsetHr = UIUtils_1.UIUtils.getCurrentUTCOffsetHours();
            webAApi_1.DoAdminLoginAction.exec({ auth_usrlogin: Login, sign: _sign, tzone_offset_hours: _TZoneOffsetHr }, function (laResp) {
                _this.props.state.SetLogged(Login, _sign); //Password);
                _this.props.state.setOrgId(laResp.org_id);
                webTransport_1.webTransport.setLogin(Login);
                webTransport_1.webTransport.setLoginKey(lrResp.loginkey);
                webTransport_1.webTransport.setSign(_sign);
                webTransport_1.webTransport.setIsLogged(true);
                if (!laResp.is_superadmin) {
                    for (var i = 0; i < laResp.documents.length; i++) {
                        if (!laResp.documents[i].visible) {
                            coreAdmin_1.ADMIN.UIState.RemoveDocument(laResp.documents[i].doc_id);
                            coreAdmin_1.ADMIN.UIState.RemoveItemByTypeDocument(laResp.documents[i].doc_id, laResp.documents[i].cat_id);
                            //ADMIN.UIState.Update("*");
                        } //else {
                        coreAdmin_1.ADMIN.UIState.setServerDocument(laResp.documents[i].doc_id, laResp.documents[i]);
                        //   alert(`!!!${laResp.documents[i].doc_id} -  ${laResp.documents[i].view}`);
                        // }
                    }
                    for (var i = 0; i < groups_1.groups.groups_avail.length; i++) {
                        if (coreAdmin_1.ADMIN.UIState.IsGroupEmpty(groups_1.groups.groups_avail[i])) {
                            //alert(`${groups.groups_avail[i]} -  empty!`);
                            coreAdmin_1.ADMIN.UIState.RemoveGroup(groups_1.groups.groups_avail[i]);
                            //ADMIN.UIState.Update("*");
                        }
                    }
                    coreAdmin_1.ADMIN.UIState.NavigateDocument(coreAdmin_1.ADMIN.UIState.GetDocument(laResp.start_url));
                    coreAdmin_1.ADMIN.UIState.Update("*");
                }
                else {
                    // ADMIN.UIState.getInitUICallback()();
                    // localStorage.setItem("mg-login", Login);
                    // localStorage.setItem("mg-sign", _sign);
                    // localStorage.setItem("mg-loginkey", lrResp.loginkey);
                    // this.props.state.setCurrencyId(laResp.def_currency_id);
                    // document.re
                }
                localStorage.setItem("mg-login", Login);
                localStorage.setItem("mg-sign", _sign);
                localStorage.setItem("mg-loginkey", lrResp.loginkey);
                _this.props.state.setCurrencyId(laResp.def_currency_id);
            }, function (laErr) {
                onError(laErr.error.info);
                return;
            });
        }, function (lrErr) {
            onError(lrErr.error.info);
            return;
        });
    };
    PAuth.prototype.ShowError = function (message) {
        this.props.dialog
            .SetMessage(message)
            .SetTitle(this.state.lang.pages.auth.error.title)
            .Show();
    };
    PAuth.prototype.OnLoginClick = function () {
        var _this = this;
        if (this.state.login.length === 0) {
            this.ShowError(this.state.lang.pages.auth.error.msg_login_empty);
            return;
        }
        if (this.state.password.length === 0) {
            this.ShowError(this.state.lang.pages.auth.error.msg_pass_empty);
            return;
        }
        this.DoLoginAction(this.state.login, this.state.password, function (reason) {
            _this.ShowError(reason);
        });
    };
    PAuth.prototype.onLoginChanged = function (e) {
        this.setState({ login: e.target.value });
    };
    PAuth.prototype.onPasswordChanged = function (e) {
        this.setState({ password: e.target.value });
    };
    PAuth.prototype.handleChange = function (value) {
        this.props.state.setLang(value.key);
    };
    PAuth.prototype.render = function () {
        if (!this.state.visible) {
            return null;
        }
        return (React.createElement("div", { style: { height: "100vh", width: "100vw", display: "flex", alignItems: "center", justifyContent: "center" } },
            React.createElement(antd_1.Card, { title: React.createElement("div", { style: { textAlign: "center" } }, "ADMIN PANEL"), bordered: true, hoverable: false, style: { width: "400px", height: "295px", boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)" } },
                React.createElement(antd_1.Card.Grid, { style: { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px", paddingTop: "20px", paddingLeft: "20px", paddingRight: "20px" } },
                    React.createElement(antd_2.Input, { addonBefore: React.createElement(antd_1.Icon, { type: "user" }), placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043B\u043E\u0433\u0438\u043D", onChange: this.onLoginChanged.bind(this), value: this.state.login })),
                React.createElement(antd_1.Card.Grid, { style: { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px", paddingLeft: "20px", paddingRight: "20px" } },
                    React.createElement(antd_2.Input, { addonBefore: React.createElement(antd_1.Icon, { type: "key" }), type: "password", placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C", onChange: this.onPasswordChanged.bind(this), value: this.state.password })),
                React.createElement(antd_1.Card.Grid, { style: { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px", paddingLeft: "20px", paddingRight: "20px" } },
                    React.createElement(InputGroup, { compact: true },
                        React.createElement(antd_2.Input, { addonBefore: React.createElement(antd_1.Icon, { type: "flag" }), style: { width: '38px' } }),
                        React.createElement(antd_3.Select, { labelInValue: true, defaultValue: { key: this.DEF_LANG }, style: { width: 'calc( 100% - 38px )' }, onChange: this.handleChange.bind(this), disabled: true },
                            React.createElement(Option, { value: "RU" }, "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"),
                            React.createElement(Option, { value: "EN" }, "English")))),
                React.createElement(antd_1.Card.Grid, { style: { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px" } },
                    React.createElement(antd_1.Button.Group, null,
                        React.createElement(antd_1.Button, { style: { width: "100px" }, type: "primary", onClick: this.OnLoginClick.bind(this) }, "LOGIN"))))));
    };
    PAuth.getPageDescription = function (state) {
        return {
            icon: "",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_auth + "-id",
            itemTitle: "",
            route: routes_1.routes.page_auth,
            docType: UiStateController_1.UIDocumentType.udtLoginPage
        };
    };
    return PAuth;
}(React.Component));
exports.default = PAuth;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/PAuth.tsx
// module id = 1745
// module chunks = 0